import React, { useCallback, useEffect, useState , useRef} from 'react';
import {
  Button,
  Navigation,
  ScrollableDynamicTable,
  StatusChip,
  SidePane,
  DateRange,
  useQueryHook
} from 'retro';
import {TOAST} from "retro/index";
import Filter from 'retro/Filter';
import { get, post } from 'App/Network/Axios';
import OpenIcon from '@atlaskit/icon/glyph/open';
import moment from 'moment';
import { DownloadCsv } from 'retro/Utils';
import FilterDropDown from 'App/Components/Filter/FilterDropDown';
import useConfigHook from 'App/Hooks/useConfigHook';


const SORT = {
  "Created On" : "createdAt",
  "Closed On": "closureOn",
}

export default function AllTicket() {
  let [loading, setLoading] = useState(false);
  const [id, setId] = useState(undefined);
  let filter = {
    status : [] ,
    module: []
   }
   const CONFIG = useConfigHook()
   const [Query,setQuery] = useQueryHook();
  const [AllClients, setAllClients] = useState();
  const REMARK = useRef();
  const MODULE = useRef();
  const TRANSID = useRef();
  const ISSUE = useRef();
  const CLIENT = useRef();
  let order = 'desc';
  let sort = 'id';
  if(Query.sort){
    sort = Query.sort;
    if(sort==null){
        sort = 'id';
    }
}   
if(Query.order){
    order = Query.order;
    if(order==null){
        order = "desc";
    }
}
  const [Data, SetData] = useState({
    total: 0,
    currentPage: 0,
    totalPages: 0,
    items: [],
  });
  const [search, setSearch] = useState({
    page:0,
    filter,
    sort,
    order,
    q: Query?.q||undefined,
  });
  const [ticketDetailPane, setTicketDetailPane] =  useState(false)
  const [ticketDetail, setTicketDetail] = useState(undefined)
  const [ticketId, setTicketId] = useState(undefined);
	const [Dates, setDates] = useState({
    startDate:moment().add(-91,'d').valueOf(),
    endDate : moment().valueOf()
  });
  const [showFilterModal,setShowFilterModal] = useState(false)
  const module = {
    'Vendor Payout':'Account Payable',
    // 'Bill Payment':'Bill Payment'
  }


  useEffect(
      ()=>{
        let mData= {
          offset: search.page,
          start: Dates.startDate,
		      end: Dates.endDate,
          sort: search.sort,
          order: search.order,
          status: search.filter.status,
          module: search.filter.module,
        };
        if(search.q!==""){
          mData["ticketId"]=search.q
        }
        get(
        `support/all/tickets`,
        (e, r) => {
          if (r) {
            SetData({
                ...r,
                currentPage: r.currentPage > 0 ? r.currentPage : 0,
                totalPages: r.totalPages > 0 ? r.totalPages : Data.totalPages,
                total: r.total > 0 ? r.total : Data.total,
              });
          } else {
            Alert.handleError(e);
          }
        },mData
      )},[search,Dates]
  );
  useEffect(() => {
    if (Dates.startDate) {
        // loadPage(search)
        setQuery(search)
    }
}, [Dates])
 
  useEffect(()=>{
    if(Dates){
        setSearch({
            ...search,
            startDate:Dates.startDate,
            endDate:Dates.endDate
        })
    }else{
        setSearch({
            ...search,
            startDate:undefined,
            endDate:undefined
        })
    }
},[Dates])
 
  const handleClose = (remark) => {
    const specialCharRegex = /[^a-zA-Z0-9\s.,]/;
    if(remark.length<1)
    {
        TOAST.error("Enter Remark");
        return
    }

    if(remark.length>100)
    {
        TOAST.error("Word limit exceeded, Word Limit 100 words")
        return
    }
    if (specialCharRegex.test(remark)) {
      TOAST.error("Remark contains special characters.");
      return;
  }
    post(`support/${ticketId}/updateStatus/${id}`,{
      status:"Close",
      remark:remark
    },(e,r)=>{
    setTicketDetailPane(false)
    if(r && r.status===true)
    {
      TOAST.success("Ticket Successfully Closed" )
      setSearch({
        page:0,
        filter
      })
    }
    else if(e){
      TOAST.handleError(e)
    }
    })
  }
  return (
    <div >
    <div style={{display:'flex' , justifyContent:'space-between'}}>
      <Navigation
        title='All Support Tickets'
        description='All the Support tickets raised are displayed here...'
        style={{marginLeft:'20px'}}
      />
       {CONFIG?.roles.includes("REPORTS")&& <div style={{display:'flex', marginTop:'-10px'}}>
        <Button
          onClick={() => {
            setLoading(true)
            get(
                `support/all/tickets/downloads`,(e,r)=>{
                if(r.supportTickets) {
                    let data = [];
                    let headers = [
                      'Ticket Id',
                      'Raised By Name',
                      'Raised By Email',
                      'Created On Date',
                      'Ticket Status',
                      'Client Name',
                      'Module Name',
                      'Transaction Id',
                      'Issue Description',
                      'Closed On',
                      'Closure Remark'
                    ];
                    data.push(headers);
                    r.supportTickets.forEach((item) => {
                        let line = [];
                        line.push(item.ticketId || '-');
                        line.push(item.raisedBy.name || '-');
                        line.push(item.raisedBy.email || '-');
                        line.push(moment(item.createdAt).format('DD MMM YYYY HH:mm') || '-');
                        line.push(item.status || '-');
                        line.push(item.clientName || '-');
                        line.push(item?.module==='Vendor Payout' ? 'Account Payable' : item?.module || '-');
                        line.push(item.transactionID || '-');
                        line.push(item.description || '-');
                        line.push(
                          item.closureOn
                            ? moment(item.closureOn).format('DD MMM YYYY HH:mm')
                            : '-'
                        );
                        line.push(item.closureRemarks || '-');
                        data.push(line);
                      }
                    );
                    DownloadCsv(`AllSupportTickets_${moment().format('DD_MM_YYYY')}.csv`, data);
                    setLoading(false)
                }},
                  { 
                    start: Dates.startDate,
                    end: Dates.endDate,
                    status: search.filter.status,
                    module: search.filter.module,
                    ticketId:search.q
                }
              );
            }} 
          loading={loading}
          style={{ zIndex: 11 }}
          className='btn absolute top-3 right-6 btn-primary'
        >
          <i className='fa fa-download mr1' />
          Download Data
        </Button>
     
        </div>}
        </div>
        <div className='flex horizontally center-vertically' style={{marginTop:'20px'}}>
				<div className="flex horizontally center-vertically" style={{width:"200px"}}>
					<div className="flex-1">
          <DateRange
      defaultValue={Dates}
      onChange={dates => {
        setDates({
          ...dates,
        });
      }}
      type="range"
    />
					</div>
				</div>
				<div>
        <Filter
        margin='20px'
      onFilter={() => setShowFilterModal(true)}
      onSearch={q => {
        setSearch({
          ...search,
          q,
        });
        setDates({
          ...Dates,
        });
      }}
      onSort={key => {
        setSearch({
          ...search,
          sort: SORT[key],
          page: 0,
          order:
            search.sort === SORT[key]
              ? search.order === "asc"
                ? "desc"
                : "asc"
              : "desc",
        });
        setDates({
          ...Dates,
        });
      }}
      sortValue={sort}
      sortChoices={Object.keys(SORT)}
    />
				</div>
			</div>

      <FilterDropDown
    onClose={() => setShowFilterModal(false)}
    shown={showFilterModal}
    setFilters={filter => {
      let reverseModule = {};
      Object.keys(module).forEach(value => {
        reverseModule[module[value]] = value;
      });
      setSearch({
        ...search,
        filter: {
          status: filter.status,
          module: filter.module.map(item => reverseModule[item]),
        },
        page: 0,
      });
      setDates({
        ...Dates,
      });
    }}
    filters={{
      status: search.filter.status || [],
      module: search.filter.module.map(item => module[item]) || [],
    }}
    selectionType={{ status: "single", module: "single" }}
    filterIcondisplay={false}
    color={"White"}
    types={["Status", "Module"]}
    choices={{ status: ["Open", "Close"], module: Object.values(module) }}
  />

        <ScrollableDynamicTable 
            setSearch={(search) => {
            setSearch({
                ...search,
                page: 0,
            });
            setDates({
              ...Dates
            })
            }}
            search={search}
            tableStyle={{
            borderSpacing: 2,
            }}
            setPage={(page) => {
            setSearch({
                ...search,
                page,
            });
            setDates({
              ...Dates
            })
            }}
            data={{
            current: Data.currentPage,
            total: Data.totalPages,
            items: Data.items.map((item) => {
                return {
                content: item,
                render: [
                    {
                        weight: 1.75,
                        children: <p className='truncate text-underline' onClick={() => {
                        get(`/support/${item.ticketId}`,(e,r)=>{
                            if(r)
                            {
                            setTicketDetail(r.ticket)
                            }
                        });
                        setTicketId(item?.ticketId)
                        setId(item?.clientId)
                        setTicketDetailPane(true)
                        }}>{item.ticketId}
                        </p>,
                    },
                    {
                    weight: 1.5,
                    children: (
                        <>{moment(item.createdAt).format('DD MMM YYYY HH:mm a')}</>
                    ),
                    },
                    {
                        weight: 1.25,
                        children: (
                        <>{item?.module==='Vendor Payout' ? 'Account Payable' : item?.module}</>
                        ),
                    },
                    {
                    weight: 1.25,
                    children: (
                        <div>
                        <p className='truncate'>{item.raisedBy.name}</p>
                        <p className='text-small truncate'>{item.raisedBy.email}</p>
                        </div>
                    ),
                    },
                    {
                        weight: .75,
                        children: (
                        <div>
                            <StatusChip className='truncate' status={item.status}/>
                        </div>
                        ),
                    },
                    {
                        weight: 1.5,
                        children: (
                        <div>
                            <p className='truncate '>{item?.closureOn ? moment(item?.closureOn).format('DD MMM YYYY HH:mm a') : "-"}</p>
                            </div>
                        )
                    },{
                        weight: .75,
                        buttons: [
                        {
                            title: 'View',
                            className: "btn-secondary btn-sm",
                            before: <OpenIcon size='small' />,
                            onClick: () => {
                            get(`/support/${item.ticketId}`,(e,r)=>{
                                if(r)
                                {
                                setTicketDetail(r.ticket)
                                }
                            });
                            setTicketId(item?.ticketId)
                            setId(item?.clientId)
                            setTicketDetailPane(true)
                            }},
                        ,
                        ],}
                ],
                };
            }),
            }}
            headers={[
            {
                weight: 1.75,
                title: 'Ticket Id',
            },
            {
                weight: 1.5,
                title: 'Created On',
            },
            {
                weight: 1.25,
                title: 'Module Name',
            },
            {
                weight: 1.25,
                title: 'Issue Raised By',
            },
            {
                weight: .75,
                title: 'Status',
            },
            {
                weight: 1.5,
                title: 'Closed On',
            },
            {
                weight: .75,
                title: 'Action',
                style: {
                justifyContent: 'end',
                },
            }
            ]}
        />
      {
            ticketDetailPane &&
            <SidePane width={450}  description="" title={"Ticket Details"} onClose={()=>{
                setTicketDetailPane(false)
            }}>
              <div>
                <div className='mt1'>
                  <h3 className='mb1'>Details</h3>
                  <div className='flex'><h4 className='mb1'>TicketID - </h4>  <p>{ticketDetail?.ticketId}</p></div>
                  <div className='flex'><h4 className='mb1'>Issue Raised By -  </h4>  <p>{ ticketDetail?.raisedBy?.name} ( { ticketDetail?.raisedBy?.email} )</p></div>
                  <div className='flex'><h4 className='mb1'>Created On - </h4> <p> {moment(ticketDetail?.createdAt).format("DD-MMM-YYYY HH:mm a")}</p></div>
                  <div className='flex'><h4 className='mb1'>Status - </h4>  <p>{ticketDetail?.status}</p></div>
                  <div className='flex'><h4 className='mb1'>Client Name - </h4>  <p>{ticketDetail?.clientName || '-'} ({ticketDetail?.clientId || '-'})</p></div>
                  <div className='flex'><h4 className='mb1'>Module Name - </h4>  <p>{ticketDetail?.module==='Vendor Payout' ? 'Account Payable' : ticketDetail?.module || '-'}</p></div>
                  <div className='flex'><h4 className='mb1'>Transaction Id - </h4>  <p>{ticketDetail?.transactionID || '-'}</p></div>
                  <div className='flex'><h4 className='mb1'>Issue Description - </h4>  <p>{ticketDetail?.description}</p></div>
                  {ticketDetail?.status==='Close' &&   <div className='flex'><h4 >Closure Remark - </h4>  <p>{ticketDetail?.closureRemarks}</p></div>}
                 {ticketDetail?.status==='Open' && CONFIG.roles.includes("SUPPORT_TICKET_WRITE") && <div className='mt4'> <h4 >Write Your Closure Remark Here*</h4>
                  <p style={{
                    fontSize:' 12px',
                    marginBottom:'4px',
                    color:'#d48929'
                  }}>You can enter up to 100 words, Special characters are not allowed.</p>
                    <textarea
                    rows="4"
                    cols="50"
                    ref={REMARK}
                    style={{
                        resize: "vertical", 
                        width: "100%", 
                        border: "1px solid #666", 
                        borderRadius: "4px", 
                        padding: "8px", 
                    }}
                ></textarea>
                  <Button className='btn btn-black' onClick={()=>handleClose(REMARK.current.value)}>Mark as Close</Button></div>}
                </div>
              </div>
            </SidePane>
            }
           
    </div>
  );
}
